import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const SidebarToggle = props => {
  const { isOpen, expandSidebar, collapseSidebar } = props;
  const handleClick = isOpen ? collapseSidebar : expandSidebar;

  const toggleClassNames = classnames({
    SidebarToggle: true,
    collapsed: !isOpen,
    expanded: isOpen,
  });

  const spanClassNames = classnames({
    icon: true,
    collapsed: !isOpen,
    expanded: isOpen,
  });

  return (
    <div className={toggleClassNames}>
      <button onClick={() => handleClick()}>
        <span className={spanClassNames} />
      </button>
    </div>
  );
};

SidebarToggle.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  expandSidebar: PropTypes.func.isRequired,
  collapseSidebar: PropTypes.func.isRequired,
};

export default SidebarToggle;



// WEBPACK FOOTER //
// ./src/components/SidebarToggle.jsx